import Raven from "raven-js";

export default class AnalyticsHelper {
  constructor () {

  }

  static alias(user) {

    window.FS.identify(user.token_id);

    window.FS.setUserVars({
      displayName: user.name ? user.name + " " + user.last : user.email,
      email: user.email,
      // version: process.env.REACT_APP_GIT_TAG
    })

    window.mixpanel.alias(user.token_id)
    // // SENTRY
    Raven.setUserContext({
        email: user.email,
        id: user.token_id
    })
  }

  static identify(user) {
    window.mixpanel.identify(user.token_id)

    // FULLSTORY
    window.FS.identify(user.token_id);

    window.FS.setUserVars({
      displayName: user.name ? user.name + " " + user.last : user.email,
      email: user.email,
      // version: process.env.REACT_APP_GIT_TAG
    })

    // // SENTRY
    Raven.setUserContext({
        email: user.email,
        id: user.token_id
    })

    window.profitwell('user_email', user.email);
    window.profitwell('cq_get');
  }

  static trackEvent(event_name, properties={}){
      window.mixpanel.track(event_name, properties);
  }

  static addPeopleProperty(token_id, properties){
    window.mixpanel.people.set(properties);
  // identify must be called along with people.set
    window.mixpanel.identify(token_id);
  }

  static clearUserCookie(){
    // window.FS.clearUserCookie();
    window.FS.identify(false)
    window.mixpanel.reset()
    // // SENTRY
    Raven.setUserContext()
  }




}


// window['_fs_ready'] = function() {
//  var sessionUrl = FS.getCurrentSessionURL();
//  // Do stuff with session URL...
// };
// FS.getCurrentSessionURL()
// also accepts an optional, boolean now parameter that causes the resulting URL
// to link directly to the current moment within the session:

// window['_fs_ready'] = function() {
//  var fsSessionUrlAtTime = window.FS.getCurrentSessionURL(true);
//  // The above URL will take you to the current time within the session
//    console.log({fsSessionUrlAtTime})
//    Raven.setExtraContext({
//       fsSessionUrlAtTime,
//       test: 'fake'
//   });
// };




// TODO
//     Raven.wrap({
//   tags: {git_commit: 'c0deb10c4'}
// }, function () { /* ... */ });



// WEBPACK FOOTER //
// ./src/utils/AnalyticsHelper.js